module.exports = __webpack_public_path__ + "img/CONSTRUCREDIX.d77ccd07.svg";